const faqs = [
    { 
        id: 1, 
        heading: 'What services does the Islamic Center provide?',
        content: 'We offer daily prayers, Friday sermons, Quran classes, Islamic counseling, youth programs, and community events to support spiritual and social well-being.',
    },
    {
        id: 2,
        heading: 'What are the prayer times?',
        content: 'Prayer times vary daily based on the Islamic calendar and location. You can check our updated prayer schedule on the website or at the center noticeboard.',
    },
    { 
        id: 3,
        heading: 'Do you offer Islamic education?',
        content: 'Yes, we provide classes for children and adults, including Quran memorization, Tajweed, Islamic studies, and Arabic language courses.',
    },
    {
        id: 4,
        heading: 'How can I donate to the center?',
        content: 'You can donate online via our secure payment system, set up recurring donations, or contribute directly at the center. All donations support community services and maintenance.',
    },
    {
        id: 5,
        heading: 'Do you host community events?',
        content: 'Yes, we organize religious celebrations, community dinners, charity drives, and youth activities to strengthen bonds within the community.',
    },
];

export default faqs;